// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_CancelEmployeeDeductionInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /payroll/cancel_employee_deduction/{id}
 *
 * Cancels an employee deduction. No body required — id is a URL path parameter.
 */
import { registerContract } from './validate'

export interface Payroll_CancelEmployeeDeductionInput {}

registerContract('Payroll_CancelEmployeeDeductionInput', {})
